import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
// import CommingSoon from "../components/CommingSoon";
import ObservershipBanner from "../components/academics/ObservershipBanner";
import { IBannerData, IBenefitsMemberFromData } from "../exports/interfaces";
import { fetchBenefitsMemberFrom } from "../api/MemberApi";
import { dynamicFailed } from "../hooks/useToast";
import BenefitsMemberFrom from "../components/benefitsmember/BenefitsMemberFrom";
import { fetchObserverShipBanner } from "../api/OurTrainingApi";

const Observership = () => {
  const { setLoading } = useLoader();
  const [observershipBannerData, setObservershipBannerData] = useState<
        IBannerData[]
      >([]);
  const [benefitsMemberData, setBenefitsMemberData] = useState<
    IBenefitsMemberFromData[]
  >([]);
  useEffect(() => {
    setLoading(true);
    Promise.all([fetchObserverShipBanner(), fetchBenefitsMemberFrom()])
      .then(([observerShipBannerData, benefitsMemberFromData]) => {
        setObservershipBannerData(observerShipBannerData);
        setBenefitsMemberData(benefitsMemberFromData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [benefitsMemberData.length, setLoading]);
  return (
    <>
      <ObservershipBanner observershipBannerData={observershipBannerData}/>
      <BenefitsMemberFrom benefitsMemberData={benefitsMemberData} />
    </>
  );
};

export default Observership;
